<template>
    <div class="tsa-CopyrightThird">
        <div class="scroll">
            <div class="breadcrumb">版权（著作权）认证</div>
            <!-- <div class="stem-container">
                <TsaSteps :active="3"></TsaSteps>
            </div> -->
            <TsaRightsInfo :result="rightsInfo"></TsaRightsInfo>
            <TsaBasicInfo :result="basicInfo"></TsaBasicInfo>
            <TsaProductionTeam :result="productionTeam" v-if="type==1"></TsaProductionTeam>
            <TsaCreateProcess :data="createProcessList" fromPage="copyrightThird" @on-loadAll="loadAll" @on-actions="actions"></TsaCreateProcess>
        </div>
        <div class="btn-groups">
            <div class="btn">
                <TsaButton plain type="default" @click="temporary">暂存草稿箱</TsaButton>
            </div>
            <div class="btn">
                <TsaButton plain type="default" @click="goback">返回修改</TsaButton>
            </div>
            <div class="btn">
                <TsaButton @click="confirm(basicInfo)" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">确认申请</TsaButton>
            </div>
        </div>
        <TsaCertificateServiceFeeDialog ref="TsaCertificateServiceFeeDialog"></TsaCertificateServiceFeeDialog>
    </div>
</template>

<script>
import copyrightThirdMinxs from '@/mixins/copyrightThird'
export default {
    mixins: [ copyrightThirdMinxs ],
}
</script>

<style lang="scss" scoped>
    .tsa-CopyrightThird {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .scroll {
            flex: 1;
            padding:0 12px 12px;
            overflow: auto;
            overflow-x: hidden;
            .breadcrumb{
                font-size: 14px;
                font-weight: bold;
                padding: 10px 4px;
            }
            .stem-container {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #FFFFFF;
                border-radius: 12px;
                margin-bottom: 16px;
            }
            .tsa-rightsInfo {
                margin-bottom: 16px;
            }
            .tsa-basicInfo {
                margin-bottom: 16px;
            }
            .tsa-productionTeam {
                margin-bottom: 16px;
            }
            .tsa-createProcess {
                margin-bottom: 16px;
            }
        }
        .btn-groups {
            flex-shrink: 0;
            width: 100%;
            height: 78px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            background: #FFFFFF;
            box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
            padding: 0 16px;
            box-sizing: border-box;
            .btn {
                flex: 1;
                margin-right: 12px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>